import { AgentRunHistoryEntry } from 'app/modules/agent-library/models/agent-run.model';

/**
 * The date a run started, taken out of its pre-formatted `meta` (`date · time · who · id`).
 *
 * The date alone is what tells two runs apart in a list: several of an agent's runs share a scenario
 * (both of Service Level's read `Weekly run · all DCs`), so a list keyed on the scenario alone shows
 * the same row twice.
 */
export function runDateOf(run: AgentRunHistoryEntry): string {
  return run.meta.split('·')[0].trim() || run.meta;
}
